export default "__VITE_ASSET__DIKPHzlw__"